export * from "-!../../../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--9-0!../../../../node_modules/vue-style-loader/index.js!../../../../node_modules/css-loader/index.js??ref--9-2!../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LanguageSelector.vue?vue&type=style&index=0&id=2497f7c4&prod&lang=scss"


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/navbar/LanguageSelector.vue?vue&type=style&index=0&id=2497f7c4&prod&lang=scss
// module id = iBgA
// module chunks = 41